/**
 * Parse async home-transfer invite links:
 * `#/register_unit_transfer/{token}/{email}/{unit_id}?action=accept|decline`
 *
 * `unit_id` is a path segment on decline links (accept may omit it).
 * Query `unit_id` / `unitId` is a fallback.
 */
import type { UnitTransferInvite } from 'src/types/UnitTransfer';

export function parseUnitTransferInvite(locationPath: string, query = ''): UnitTransferInvite | null {
	const match = locationPath.match(/^\/register_unit_transfer\/([^/]+)\/([^/]+)(?:\/([^/?]+))?/);
	if (!match) {
		return null;
	}

	const searchParams = new URLSearchParams(query.startsWith('?') ? query.slice(1) : query);
	const action = searchParams.get('action') === 'decline' ? 'decline' : 'accept';
	const unitId =
		Number(match[3] || searchParams.get('unit_id') || searchParams.get('unitId')) || undefined;

	return {
		token: match[1],
		email: decodeURIComponent(match[2]),
		action,
		unitId,
	};
}
